import { ActionInput } from '@/components/shared/ActionInput';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  useOrganization,
  useUpdateOrganizationName,
} from '@/hooks/api/useOrganizations';

interface OrganizationProfileSettingsProps {
  organizationId: string;
}

export const OrganizationProfileSettings = ({
  organizationId,
}: OrganizationProfileSettingsProps) => {
  const { data } = useOrganization(organizationId);
  const updateNameMutation = useUpdateOrganizationName(organizationId);
  const defaultName = data?.name || '';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2.5">
          Organization Profile Settings
        </CardTitle>
        <CardDescription>
          Update your organization's profile information.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ActionInput
          saveAction={async (value: string) => {
            return updateNameMutation.mutateAsync({
              name: value,
            });
          }}
          label="Organization Name"
          scopeId="update-organization-name"
          defaultValue={defaultName}
          showInlineToast={true}
          isSaveLoading={updateNameMutation.isPending}
          validator={{
            required: { value: true, message: 'Organization name is required' },
            maxLength: {
              value: 254,
              message: 'Organization name cannot exceed 254 characters',
            },
          }}
        />
      </CardContent>
    </Card>
  );
};
